/*------------------------------------*/
/*       AUTH CONFIG CONSTANTS        */
/*------------------------------------*/
export const AUTH_CLIENT_ID = process.env.REACT_APP_AUTH_CLIENT_ID;
export const AUTH_ADMIN_IDENTITY_GROUP_ID = process.env.REACT_APP_AUTH_ADMIN_IDENTITY_GROUP_ID;
export const AUTH_IDENTITY_POOL_ID = process.env.REACT_APP_AWS_IDENTITY_POOL_ID;
export const AUTH_USER_POOL_ID = process.env.REACT_APP_AWS_USER_POOL_ID;

export const AUTH_EVENT_NAME = 'auth';
export const AUTH_CONFIG_RESPONSE_TYPE = 'code';
export const AUTH_CONFIG_SCOPE = [
    "aws.cognito.signin.user.admin",
    "email",
    "openid",
    "profile",
    "phone"
];